import React, { useEffect } from "react";
import { Table } from "antd";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import RewardForm from "./RewardForm"; 
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import {
  getRewardList,
  doRewardDelete,
  doRewardReset,
} from "../../../../redux/reward/rewardState";

const RewardTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {

  const columns = [
    {
      title: "Award Title",
      dataIndex: "rwd_title",
      key: "rwd_title",
      width: "25%",
      render: (rwd_title) => <span>{rwd_title}</span>,
    },
    {
      title: "Description",
      dataIndex: "rwd_description",
      key: "rwd_description",
      width: "55%",
      render: (rwd_description) => <span>{rwd_description}</span>,
    },
        {
      title: "Points",
      dataIndex: "rwd_points",
      key: "rwd_points",
      width: "10%",
      render: (rwd_description) => <span>{rwd_description}</span>,
    },
    {
      title: (
        <PopupButton id="add_reward" title="Add reward" label="Add" btnClass="btn-small">
          <RewardForm recordId="0" mode="edit" />
        </PopupButton>
      ),
      dataIndex: "rwd_id",
      key: "rwd_id",
      width: "10%",
      render: (_, record) => (
        <CrudOption
          baseRoute="/console/rewards"
          recordId={record?.rwd_id}
          deleteHandler={doDelete}
          allowEdit={true}
          allowView={false}
          editMode="modal"
          modalWidth={900}
          title="Edit reward"
          closeHandler={doRecordReset}
          editHandler={(recordId, doRecordReset ) => (
            <RewardForm recordId={recordId} mode="edit" onCancel={doRecordReset} />
          )}
        />
      ),
    },
  ];

	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
        <Table
          dataSource={recordList}
          columns={columns}
          rowKey={(record) => record.rwd_id}
		      pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}   
          onChange={handleTableChange(doSearch, filters)}
        />
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.reward.rewardList?.items,
	pagination: state.reward.rewardList?.pagination,
	filters: state.reward.rewardList?.filters,
	requesting: state.reward.rewardList?.requesting,
	error: state.reward.rewardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getRewardList(filters)),
  doDelete: (id) => dispatch(doRewardDelete(id)),
  doRecordReset: () => dispatch(doRewardReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RewardTable);
